import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { SUPPORT_TICKET_ENDPOINT } from '../consts';

export const useSupportTicket = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const submit = useCallback(
    async (data: { category: string; message: string }) => {
      return await executeRequest(() => axios.post(SUPPORT_TICKET_ENDPOINT, data));
    },
    [executeRequest]
  );

  return { loading, error, submit };
};
